// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import axios from './utils/axios';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import 'vue-area-linkage/dist/index.css';
import VueAreaLinkage from 'vue-area-linkage';
import DrawerLayout from 'vue-drawer-layout';
import 'lib-flexible/flexible.js'
import 'amfe-flexible/index.js'
import VideoPlayer from 'vue-video-player'
import 'vue-video-player/src/custom-theme.css'
import 'video.js/dist/video-js.css'
import 'babel-polyfill'
import './styles/font.css'
import i18n from './utils/i18n'  //引入i18n

const isPro = Object.is(process.env.NODE_ENV, 'production');
Vue.prototype.$axios = axios;
axios.defaults.baseURL = isPro ? process.env.BASE_API : 'api/';
Vue.use(DrawerLayout);
Vue.use(VueAreaLinkage);
Vue.use(ElementUI);
Vue.use(VideoPlayer);

Vue.config.productionTip = false;
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
});
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  components: {App},
  template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js